// extracted by mini-css-extract-plugin
export default {"hoverText":"bubble_hoverText__aw6Qa"};